<template>
  <div
    class="pdf-viewer-wrap rel flex-col-1"
    :style="{
      height: height === 'auto' ? '100%' : '',
      'background-color': '#d4d4d6',
    }"
  >
    <div class="toolbar">
      <div>
        <span v-show="pagesCount">{{ `${currentPage}/${pagesCount}` }}</span>
      </div>
    </div>
    <div v-loading="loading" class="pdf-loading"></div>

    <div
      id="viewerContainer"
      ref="container"
      :style="{ 'background-color': '#d4d4d6', overflowY: 'auto', height }"
      class="abs"
    >
      <div id="viewer" class="pdfViewer"></div>
    </div>
  </div>
</template>

<script>
const pdfJsLib = require("pdfjs-dist");
const workSrc = require("pdfjs-dist/build/pdf.worker.entry");
const pdfjsViewer = require("pdfjs-dist/web/pdf_viewer");

import "pdfjs-dist/web/pdf_viewer.css";

pdfJsLib.GlobalWorkerOptions.workerSrc = workSrc;

const cMapUrl = `/static/cmaps/`;

export default {
  name: "PdfViewer",
  props: {
    pdfUrl: {
      type: String,
      required: true,
    },
    height: {
      type: String,
      default: "auto",
    },
  },
  data() {
    return {
      scale: 0,

      pdfViewer: null,
      pdfDocument: null,
      pdfPageViews: [],

      loading: false,
    };
  },

  computed: {
    currentPage({ pdfViewer }) {
      console.log(pdfjsViewer);
      return pdfViewer?.currentPageNumber || "";
    },

    pagesCount({ pdfDocument }) {
      return pdfDocument?.numPages || "";
    },
  },

  async mounted() {
    await this.loadPdf();
    this.renderPdf();
    // this.renderThumbnailView();
  },

  beforeDestroy() {
    this.close();
  },

  methods: {
    async loadPdf() {
      const loadingTask = pdfJsLib.getDocument({
        url: this.pdfUrl,
        cMapUrl,
        cMapPacked: true,
      });

      try {
        this.loading = true;
        const pdfDocument = await loadingTask.promise;
        this.loading = false;

        this.pdfDocument = pdfDocument;
      } catch (error) {
        this.loading = false;
        this.$message.error("加载pdf文件失败，请刷新重新加载");
      }
    },

    scaleChange(scale) {
      this.scale = scale * 100;
    },

    async renderPdf() {
      const container = this.$refs.container;
      const eventBus = new pdfjsViewer.EventBus();

      // eventBus.on('pagechanging', (event) => {
      //   console.log(event);
      // });

      // 初始化 PDF 阅读器
      const pdfViewer = new pdfjsViewer.PDFViewer({
        container,
        eventBus,
        textLayerMode: 1,
      });

      pdfViewer.setDocument(this.pdfDocument);
      this.pdfViewer = pdfViewer;

      this.scaleChange(pdfViewer.currentScale);
    },

    close() {
      if (this.pdfDocument) {
        this.pdfDocument = null;

        this.pdfViewer.setDocument(null);
      }
    },
  },
};
</script>

<style>
.rel {
  position: relative;
}

.abs {
  position: absolute;
}

.pdfViewer .page {
  box-sizing: content-box;
}

.toolbar {
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  padding: 10px;
  background: #f9f9f9;
  border-bottom: 1px solid #ccc;
  z-index: 1;
}

.toolbar__icon {
  padding: 4px;
}

.toolbar__icon:hover {
  background: #d7d6db;
}

#viewerContainer,
.pdf-loading {
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
}

.flex-col-1 {
  display: flex;
  flex-direction: column;
  flex: 1 1 auto;
}

.pdfViewer {
  margin-top: 40px;
}
</style>
